import { cloneElement } from 'react'
import { useMergeRefs } from '@floating-ui/react'

function FloatingSelectControl({ ref: propRef, ...props }) {
  const { children, context } = props

  const mergedRef = useMergeRefs([
    context.refs.setReference,
    propRef,
    children.props.ref,
  ])

  return cloneElement(children, { ...children.props, ref: mergedRef })
}

export default FloatingSelectControl
